<template>
  <div class="rule-selection"
       :class="{'valid': !ruleContent.validation.disabled}">
    <select :name="ruleContent.key"
            :id="ruleContent.key"
            :disabled="ruleContent.validation.disabled"
            :style="{backgroundColor: ruleContent.validation.disabled ? '#fff' : 'transparent'}"
            v-model="activeSelection">
      <option v-for="(option, index) in ruleContent.validation.enum"
              :key="index"
              :value="option">{{option}}</option>
    </select>
  </div>
</template>

<script>
import rulesProps from '../mixins';

export default {
  name: 'SelectBox',
  data() {
    return {
      activeSelection: null,
      options: [],
    };
  },
  mixins: [rulesProps],
  mounted() {
    this.activeSelection = this.ruleValue;
  },
  watch: {
    ruleValue(newValue) {
      this.activeSelection = newValue;
    },
    activeSelection(newSelection) {
      if (newSelection) {
        this.$emit('input-section-box-action', {
          key: this.ruleKey,
          value: this.activeSelection,
          action: null,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .rule-selection {
    height: 100%;
    width: 220px;
    position: relative;
    select {
      border-radius: 0;
      height: 100%;
      padding: 6px 12px;
      position: relative;
      z-index: 1;
      width: 100%;
    }
    &.valid {
      background-color: #fff;
      &:after {
        content: '\e701';
        font-family: "SEVEN";
        font-size: 12px;
        position: absolute;
        padding: 0 0 2px;
        right: 12px;
        top: 8px;
      }
    }
  }
</style>
